export { GalleriaComponent } from "./galleria.component";
export * from "./galleria.modal";
export { GalleriaService } from "./galleria.service";
